import { render, staticRenderFns } from "./ModuleSingle.vue?vue&type=template&id=15a08dd9&scoped=true&"
import script from "./ModuleSingle.vue?vue&type=script&lang=js&"
export * from "./ModuleSingle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSingle.vue?vue&type=style&index=0&id=15a08dd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a08dd9",
  null
  
)

export default component.exports